export const POLLS_RESET_STATE = 'POLLS_RESET_STATE';
export const POLLS_CURRENT_ITEM = 'POLLS_CURRENT_ITEM';

export const POLLS_REQUEST_LOADING = 'POLLS_REQUEST_LOADING';
export const POLLS_REQUEST_SUCCESS = 'POLLS_REQUEST_SUCCESS';
export const POLLS_REQUEST_FAILED = 'POLLS_REQUEST_FAILED';

export const POLLS_CURRENT_ACTION = 'POLLS_CURRENT_ACTION';
export const POLLS_RESET_ACTION = 'POLLS_RESET_ACTION';